import { render, staticRenderFns } from "./simpleForm.vue?vue&type=template&id=22bd1583&scoped=true"
import script from "./simpleForm.vue?vue&type=script&lang=js"
export * from "./simpleForm.vue?vue&type=script&lang=js"
import style0 from "./simpleForm.vue?vue&type=style&index=0&id=22bd1583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd1583",
  null
  
)

export default component.exports